const es = {
    translation: {},
};

export { es };
